// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import { getFontsURL } from '@tcp/core/src/utils';

class PriceCurrency extends React.Component {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
  }

  componentDidMount() {
    this.adjustIframeSize();
  }

  adjustIframeSize = () => {
    const iframe = this.iframeRef.current;
    if (iframe) {
      iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`;
      iframe.style.width = `${iframe.contentWindow.document.body.scrollWidth}px`;
    }
  };

  render() {
    const {
      currency,
      currencySymbol,
      price,
      preFixLabel,
      postFixLabel,
      isPriceOnIframe,
      isPDPPriceIframeEnabled,
    } = this.props;
    const space = currency === 'USD' || currency === 'CAD' ? '' : ' ';
    if (isPriceOnIframe && isPDPPriceIframeEnabled) {
      return (
        <iframe
          ref={this.iframeRef}
          title="Price Display"
          srcDoc={`<html><style>@font-face{font-family:'Nunito';font-style:normal;font-weight:800;font-display:swap;src:local('Nunito ExtraBold'),local('Nunito-ExtraBold'),url(${getFontsURL(
            'fonts/Nunito-800.woff2'
          )}) format('woff2'),url(${getFontsURL('fonts/Nunito-800.woff')}) format('woff')
url('https://assets.theplace.com/rwd/fonts/Nunito-800.woff2'),}
</style><body style="display: inline-block; margin: 0;"><span style="color: #000;
    display: inline-block;font-size: 22px;
    font-weight: 800; font-family: Nunito;font-style: normal;">${preFixLabel}${currencySymbol}${
            (currency && space) || ''
          }${
            price?.toString()?.includes('-') ? price : (Number(price) || 0).toFixed(2)
          }${postFixLabel}</span></body></html>`}
          className="price-iframe"
          onLoad={this.adjustIframeSize}
          frameBorder="0"
          style={{ width: '35%', height: '40px' }}
        />
      );
    }
    return `${preFixLabel}${currencySymbol}${(currency && space) || ''}${
      price?.toString()?.includes('-') ? price : (Number(price) || 0).toFixed(2)
    }${postFixLabel}`;
  }
}

PriceCurrency.propTypes = {
  currency: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  preFixLabel: PropTypes.string,
  postFixLabel: PropTypes.string,
};

PriceCurrency.defaultProps = {
  preFixLabel: '',
  postFixLabel: '',
};

export default errorBoundary(PriceCurrency);
export { PriceCurrency as PriceCurrencyVanilla };
